import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Table,
  Tbody,
  Td,
  Tr,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import CrmDataService from "../../services/data";

export const SessionPlanModal = ({
  isOpen,
  onClose,
  expert,
  user_session_plans,
}: any) => {
  const [data, setData] = useState<any>({});

  console.log(user_session_plans, "user_session_plans");

  const getSessionPlan = () => {
    const plan = user_session_plans?.find((p: any) => p.expert_id === expert);

    const latestSession = plan?.session_plans?.at(-1) || {};

    setData(latestSession);
  };

  useEffect(() => {
    getSessionPlan();
  }, []);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        size="2xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius="lg" p={4}>
          <ModalHeader
            color="#16817A"
            fontWeight="extrabold"
            textAlign="center"
          >
            CLIENT SESSION PLAN
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            {" "}
            <Table variant="striped" size="md">
              <Tbody>
                <Tr>
                  <Td fontWeight="semibold">Session Summary</Td>
                  <Td>{data.session_summary || "—"}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="semibold">Next Session Goal</Td>
                  <Td>{data.next_session_goal || "—"}</Td>
                </Tr>
              </Tbody>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
